import React from "react";
import { t } from "ttag";

import { IBasket } from "../../../models/catalogue";
import { format } from "../../../utils/format";
import { Dinero, getDinero } from "../../../utils/money";

import styles from "./common.module.scss";

const getGrandTotal = ({
    basket,
    shippingExclTax,
    grandTotal,
    disableShipping,
    disableTaxes,
}: {
    basket: IBasket;
    shippingExclTax: Dinero;
    grandTotal: Dinero | null;
    disableShipping: boolean;
    disableTaxes: boolean;
}): Dinero | null => {
    if (disableShipping && disableTaxes) {
        return getDinero(basket.total_excl_tax);
    }
    if (disableShipping) {
        return getDinero(basket.total_incl_tax);
    }
    if (disableTaxes) {
        return getDinero(basket.total_excl_tax).add(shippingExclTax);
    }
    return grandTotal;
};

export const GrantTotalRow = (props: {
    basket: IBasket;
    shippingExclTax: Dinero;
    grandTotal: Dinero | null;
    disableShipping: boolean;
    disableTaxes: boolean;
}): React.ReactNode => (
    // TODO(i18n): Use c() context to disambiguate "Total" (sum) vs "Total" (adjective): c("checkout summary").t`Total`
    // TODO(i18n): Should verify format.money() properly handles locale-specific formatting and RTL currencies
    <span className={styles.line}>
        <li className={styles.bold}>{t`Total`}</li>
        <li className={styles.bold}>{format.money(getGrandTotal(props))}</li>
    </span>
);
